<template>
    <div id="pane-tag"
        class="pane-tag"
    >
        <div style="display: flex; flex-direction: column; align-items: end;">
            <div
                class="map-pane-tag"
                :class="{ 
                    'map-pane-tag--active': options.is_on_map,
                    'map-pane-tag--no_data_pink': !options.has_layer && !options.is_loading && tag_config.no_data === 'pink',
                }"
            >
                <div>{{ options.text }}</div>
            </div>

            <!-- 為了截圖時顯示在右上角的投落送文字可以顯示hPa，新增此段 -->
            <div
                v-if="options.name === 'id_81'"
                class="map-pane-tag"
                :class="{ 
                    'map-pane-tag--active': options.is_on_map,
                    'map-pane-tag--no_data_pink': !options.has_layer && !options.is_loading && tag_config.no_data === 'pink',
                }"
            >
                {{ `hPa: ${this.dropsonde.hPa}` }}
            </div>
        </div>

        <span v-if="forecast_text" 
            v-html="forecast_text" 
            class="data-time-tag" 
        />
    </div>
</template>

<script>
    import { mapState } from "vuex";
    export default {
        name: "PaneTag",
        
        props: {
            options: {
                type: Object,
                require: true,
                default: () => ({})
            }
        },
        
        computed: {
            ...mapState('emap', [
                'current_timestamp',
                'dropsonde'
            ]),

            tag_config() {
                return this.options.tag_config || {};
            },

            forecast_timestamp() {
                if (
                    this.tag_config?.initial_time_list?.length > 0 &&
                    this.options.data?.list?.length >= 0
                ) {
                    const compared_key = `${this.options.name}_${this.current_timestamp}`;
                    const current_timestamp_index = this.options.data.list.findIndex(element => element.key === compared_key);
                    if (current_timestamp_index >= 0) {
                        return [
                            this.tag_config.initial_time_list[current_timestamp_index],
                            this.current_timestamp,
                        ];
                    }
                }
                return [];
            },

            forecast_text() {
                if (this.forecast_timestamp.length !== 0) {
                    const initial_time_in_date_format = new Date(Number(this.forecast_timestamp[0]));
                    const forecast_time_in_date_format = new Date(Number(this.forecast_timestamp[1]));
                    const initial_time_string = this._get_time_string(initial_time_in_date_format);
                    const forecast_time_string = this._get_time_string(forecast_time_in_date_format);
                    return `
                    └─${this.$t("__product_setting.init_text")}: ${initial_time_string}<br>
                    └─${this.$t("__product_setting.forecast_text")}: ${forecast_time_string}
                    `;
                }
                return "";
            },
        },
        methods: {
            delete_pane: function () {
                this.$emit("delete_pane", this.options.name);
            },

            _get_time_string(d) {
                return `${("00" + (d.getMonth() + 1)).slice(-2)}/${("00" + d.getDate()).slice(-2)} ${("00" + d.getHours()).slice(-2)}:${("00" + d.getMinutes()).slice(-2)}`;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .pane-tag {
        display: none;
    }

    .map-pane-tag {
        position: relative;
        top: .15rem;
        display: block;
        margin: 0 .35rem;
        padding: 0 .2rem;
        width: fit-content;
        height: 1.8rem;
        font-size: 1rem;
        line-height: 1.8rem;
        color: var(--grey-pipe);
        background-color: var(--base-gray-darken); 
        border-radius: 5px;
        box-shadow: 0 0 0 1px var(--base-dark-blue);

        &--active {
            color: #fff;
            background-color: var(--base-gray);
            box-shadow: 0 0 0 1.5px var(--aqua-active);
        }

        &--no_data_pink::before {
            content: "▲目前未發布 ";
            font-size: .75rem;
        }
    }

    .data-time-tag {
        position: relative;
        display: inline-block;
        padding: 2px 5px;
        width: 90%;
        font-size: 10px;
        line-height: 11px;
        text-align: right;
        color: #fafafa;
    }

    .pane-tag-flex {
        display: flex;
        flex-direction: column;
        align-items: end;
    }
</style>